import qs from 'qs';
import Router from 'next/router';

type RouteToParams = {
  url: string;
  as?: string | null;
  options?: Parameters<typeof Router.push>[2];
  queryParams?: Record<string, unknown>;
  scrollReset?: boolean;
};

/**
 * Wrapper around Router.push, to handle query params and scroll to the top of the page if needed because it will not
 * do this by default (see: https://github.com/zeit/next.js/issues/3249)
 */
export default function routeTo({
  url,
  as = null,
  options = undefined,
  queryParams = undefined,
  scrollReset = false,
}: RouteToParams): void {
  const stringifiedQueryParams = queryParams ? `?${qs.stringify(queryParams)}` : '';
  const asPath = as ? `${as}${stringifiedQueryParams}` : undefined;
  const route = `${url}${stringifiedQueryParams}`;

  // The original helper intentionally returns `undefined` rather than Router.push's promise;
  // `void` makes that fire-and-forget contract explicit without changing rejection behavior.
  void Router.push(route, asPath, options).then(() => {
    if (scrollReset) {
      window.scrollTo(0, 0);
    }
  });
}
